import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
const colors = {
    blue: 'bg-blue-400 dark:bg-blue-600',
    orange: 'bg-orange-400 dark:bg-orange-600',
    green: 'bg-green-400 dark:bg-green-600',
    red: 'bg-red-400 dark:bg-red-600',
    zinc: 'bg-zinc-400 dark:bg-zinc-600'
};
const methods = {
    get: 'blue',
    put: 'orange',
    post: 'green',
    delete: 'red',
    options: 'zinc',
    head: 'zinc',
    patch: 'orange',
    trace: 'zinc'
};
export function OperationSummary({ path, method, operation }) {
    const { summary } = operation;
    return (_jsxs("div", { className: "mr-24 flex w-full items-center space-x-2 p-2", children: [_jsx("div", { className: clsx('w-16 shrink-0 rounded py-1 text-center text-xs font-bold text-white', colors[methods[method]]), children: method.toUpperCase() }), _jsxs("p", { className: "space-x-2 text-start", children: [_jsx("span", { className: "text-sm font-semibold text-zinc-500 dark:text-white/50", children: _jsx("code", { children: path }) }), _jsx("span", { className: "text-sm font-medium text-zinc-700 dark:text-white/70", children: summary !== null && summary !== void 0 ? summary : 'No summary available' })] })] }));
}
